import dayjs from 'dayjs'
import {get} from 'lodash'
import {message} from 'antd'
import createModel from 'utils/model'
import {chatList, groupChatList, groupMembers} from 'message-control/services/message-history'
import constants from '../../common/constants'

const {dateFormat} = constants

export default createModel({
    namespace: 'messageControl_messageHistory',
    state: {
        chatTableData: {},
        groupChatTableData: {},
        groupMembersTableData: {},
    },
    subscriptions: {},
    effects: {
        *chatList(_, {select, call, put}) {
            const {chatTableData} = yield select(
                ({messageControl_messageHistory}) => messageControl_messageHistory,
            )
            const query = {
                offset: chatTableData.pagination.pageSize * (chatTableData.pagination.current - 1),
                limit: chatTableData.pagination.pageSize,
                ...chatTableData.params,
            }
            if (query?.time?.[0]) {
                query.start_at = dayjs(
                    `${dayjs(query.time[0]).format(dateFormat)} 00:00:00`,
                ).valueOf()
            }
            if (query?.time?.[1]) {
                query.end_at = dayjs(
                    `${dayjs(query.time[1]).format(dateFormat)} 23:59:59`,
                ).valueOf()
            }
            delete query.time

            const queryKeySets = new Set()

            Object.keys(query).forEach((key) => {
                if (key !== 'offset' && key !== 'limit') {
                    if (query[key]) {
                        queryKeySets.add(key)
                    }
                }
            })

            if (!queryKeySets.size) {
                message.warn(`消息查询量过大，需带上查询条件`)

                return
            }

            const res = yield call(chatList, query)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.chatTableData.dataSource = res.data
                    draft.chatTableData.pagination.total = get(res, 'pagination.rows_found', 0)
                },
            })
            return res
        },
        *groupChatList(_, {select, call, put}) {
            const {groupChatTableData} = yield select(
                ({messageControl_messageHistory}) => messageControl_messageHistory,
            )
            const query = {
                offset:
                    groupChatTableData.pagination.pageSize *
                    (groupChatTableData.pagination.current - 1),
                limit: groupChatTableData.pagination.pageSize,
                ...groupChatTableData.params,
            }
            if (query?.time?.[0]) {
                query.start_at = dayjs(
                    `${dayjs(query.time[0]).format(dateFormat)} 00:00:00`,
                ).valueOf()
            }
            if (query?.time?.[1]) {
                query.end_at = dayjs(
                    `${dayjs(query.time[1]).format(dateFormat)} 23:59:59`,
                ).valueOf()
            }
            delete query.time

            const queryKeySets = new Set()

            Object.keys(query).forEach((key) => {
                if (key !== 'offset' && key !== 'limit') {
                    if (query[key]) {
                        queryKeySets.add(key)
                    }
                }
            })

            if (!queryKeySets.size) {
                message.warn(`消息查询量过大，需带上查询条件`)

                return
            }

            const res = yield call(groupChatList, query)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.groupChatTableData.dataSource = res.data
                    draft.groupChatTableData.pagination.total = get(res, 'pagination.rows_found', 0)
                },
            })
            return res
        },
        *groupMembers(_, {call, put, select}) {
            const {groupMembersTableData} = yield select(
                ({messageControl_messageHistory}) => messageControl_messageHistory,
            )
            const query = {
                offset:
                    groupMembersTableData.pagination.pageSize *
                    (groupMembersTableData.pagination.current - 1),
                limit: groupMembersTableData.pagination.pageSize,
                ...groupMembersTableData.params,
            }

            const res = yield call(groupMembers, query)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.groupMembersTableData.dataSource = res.data
                    draft.groupMembersTableData.pagination.total = get(
                        res,
                        'pagination.rows_found',
                        0,
                    )
                },
            })
            return res
        },
    },
    reducers: {},
})
